import { WindowConf, createDefaultWindowConf } from "@droid/android"
import { ulid } from "ulid"
import { createActionUtils, IAction, IActionJavaData, IActionWebConfig } from "@droid/project-v2-interface"
import { floatWindowActionNamespace } from "../float-window-namespace"
import { IActionShowFloatWindowUI } from "./IActionShowFloatWindow.UI"
import { Log } from "@fanfanlo"

const fileLog = new Log(false, '[IActionShowFloatWindow]')
fileLog.pause = true
fileLog.childrenPaused = true

const type = `${floatWindowActionNamespace}showFloatWindow`
fileLog.log('[IActionShowFloatWindow] type:', type)

export interface IActionShowFloatWindowJavaData extends IActionJavaData {
    windowConf: WindowConf
}

export interface IActionShowFloatWindowWebConfig extends IActionWebConfig {
    // Show Float Window Action 特有的 Web 配置
}

export interface IActionShowFloatWindowData extends IAction<IActionShowFloatWindowJavaData, IActionShowFloatWindowWebConfig> {
    javaData: IActionShowFloatWindowJavaData
}

function createDefaultData(): IActionShowFloatWindowData {
    fileLog.log('[createDefaultData] 开始创建默认数据')
    const ulidValue = ulid()
    const data: IActionShowFloatWindowData = {
        
        ulid: ulidValue,
        uuid: '',
        ownerUuid: '',
        currentVersion: 0,
        type,
        javaData: {
            windowConf: createDefaultWindowConf()
        },
        createdAt: 0,
        updatedAt: 0,
        authorUuid: '',
    }
    fileLog.log('[createDefaultData] data:', JSON.stringify(data))
    return data
}

function init() {
    fileLog.log('[init] showFloatWindow 初始化')
}

export const actionShowFloatWindowUtils = createActionUtils(type, init, createDefaultData, IActionShowFloatWindowUI)
